<div class="container mt-5">
  @if (hasApiError) {
  <div class="alert alert-danger" role="alert">
    {{apiError}}
  </div>
  }
  <table mat-table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
      <td mat-cell *matCellDef="let element"><a routerLink="/material/{{element.id}}">{{element.id}}</a></td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <ng-container matColumnDef="key_words">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Key Words</th>
      <td mat-cell *matCellDef="let element"> {{element.key_words}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element"><a [hidden]="!element.owner_user_id || element.owner_user_id == ''"
          (click)="deleteMaterial(element.id)" href="javascript:void(0)">Delete</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons aria-label="Select page of materials">
  </mat-paginator>
</div>